module.exports = __webpack_public_path__ + "static/hyperv_40.56a21bb8.jpg";